"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[9136],{

/***/ 39136:
/***/ ((module) => {

module.exports = JSON.parse('{"selectableStates":{"NST":"Ej påbörjad","IPG":"Pågående","DON":"Klar"},"selectableTypes":{"NOT":"Notering","BES":"Besök","EPO":"E-post","TEL":"Telefon","OVR":"Övrigt"}}');

/***/ })

}]);